export const FETCH_TRANSACTION_REQUEST = "FETCH_TRANSACTION_REQUEST";
export const FETCH_TRANSACTION_SUCCESS = "FETCH_TRANSACTION_SUCCESS";
export const FETCH_TRANSACTION_FAILURE = "FETCH_TRANSACTION_FAILURE";
